import { render, staticRenderFns } from "./CodePromo2.vue?vue&type=template&id=3df2b898&"
import script from "./CodePromo2.vue?vue&type=script&lang=js&"
export * from "./CodePromo2.vue?vue&type=script&lang=js&"
import style0 from "./CodePromo2.vue?vue&type=style&index=0&id=3df2b898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorsMsgs: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ErrorsMsgs.vue').default})
